// removed by extract-text-webpack-plugin
module.exports = {"container":"_2yzMbJD","header":"_3g4nBO9","button":"YvZ3lbB","locationText":"_2F4ufl5","changeLabel":"Tg743C9","countryFlag":"_2S5PiQY","withLabels":"_3n7i0ux"};


//////////////////
// WEBPACK FOOTER
// ./template/components/CountrySelectorButton/index.css
// module id = ./template/components/CountrySelectorButton/index.css
// module chunks = client.sitechrome